import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const Truck = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color2.hex,
    dmId = 'dm-truck',
    description,
    pointerEvents = 'none',
    secondColor = theme.palette.color2.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.truck.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps
  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="m5.44 15h-2.44a1 1 0 0 0 0 2h1.31a3.1 3.1 0 0 1 1.13-2z"
      />
      <path
        fill={color}
        d="m21 15h-.35v-3a2.4 2.4 0 0 0 -.32-1.32l-1.61-2.68a2.38 2.38 0 0 0 -1.93-1h-2.66a.54.54 0 0 0 -.54.54v6.81a.57.57 0 0 1 -.59.65h-3.66a3.1 3.1 0 0 1 1.13 2h3.63a3.1 3.1 0 0 1 6.15 0h.75a1 1 0 0 0 0-2zm-2.94-4h-2.78a.58.58 0 0 1 -.57-.57v-1.43a.57.57 0 0 1 .57-.56h2a.55.55 0 0 1 .49.28l.81 1.42a.57.57 0 0 1 -.52.86z"
      />
      <path
        fill={secondColor}
        d="m7.39 13.72h3.69a1.51 1.51 0 0 0 1.51-1.51v-5.21a1.51 1.51 0 0 0 -1.51-1.5h-7a1.51 1.51 0 0 0 -1.5 1.5v5.2a1.51 1.51 0 0 0 1.5 1.51z"
      />
      <ellipse fill={color} cx="7.39" cy="17.37" rx="2.12" ry="2.13" />
      <ellipse fill={color} cx="17.18" cy="17.37" rx="2.12" ry="2.13" />
    </IconSvg>
  );
};

export default memo(Truck);
